"use strict";

exports.__esModule = true;

exports.tupleElementsNotNull = function (x) {
  return x.every(function (el) {
    return el !== null;
  });
};